import { useTranslation } from 'react-i18next';

export default function OurSolution() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-first-aid-kit-line',
      title: t('brandStory.solution.feature1.title'),
      points: [
        t('brandStory.solution.feature1.point1'),
        t('brandStory.solution.feature1.point2'),
        t('brandStory.solution.feature1.point3'),
        t('brandStory.solution.feature1.point4'),
      ],
    },
    {
      icon: 'ri-shield-check-line',
      title: t('brandStory.solution.feature2.title'),
      points: [
        t('brandStory.solution.feature2.point1'),
        t('brandStory.solution.feature2.point2'),
        t('brandStory.solution.feature2.point3'),
        t('brandStory.solution.feature2.point4'),
      ],
    },
    {
      icon: 'ri-drop-line',
      title: t('brandStory.solution.feature3.title'),
      points: [
        t('brandStory.solution.feature3.point1'),
        t('brandStory.solution.feature3.point2'),
        t('brandStory.solution.feature3.point3'),
        t('brandStory.solution.feature3.point4'),
      ],
    },
  ];

  return (
    <section className="w-full bg-[#F0EFED] py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="flex flex-col gap-4 mb-12 md:mb-16 max-w-2xl">
          <div className="flex items-center gap-3">
            <div className="w-8 h-px bg-[#7B1113]" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
              {t('brandStory.solution.label')}
            </span>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-[1.15]">
            {t('brandStory.solution.heading')}
          </h2>
          <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
            {t('brandStory.solution.body')}
          </p>
        </div>

        {/* 3 feature cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className={`flex flex-col gap-6 p-8 rounded-2xl transition-all duration-300 hover:shadow-lg ${
                index === 1 ? 'bg-[#2A2A2A] text-white' : 'bg-white text-[#2A2A2A]'
              }`}
            >
              {/* Icon */}
              <div
                className={`w-14 h-14 rounded-xl flex items-center justify-center ${
                  index === 1 ? 'bg-white/10' : 'bg-[#F0EFED]'
                }`}
              >
                <i
                  className={`${feature.icon} text-xl ${
                    index === 1 ? 'text-[#7B1113]' : 'text-[#1B3A5C]'
                  }`}
                />
              </div>

              {/* Title */}
              <div className="flex flex-col gap-3">
                <h3 className="font-serif text-xl font-semibold">{feature.title}</h3>
                <ul className="flex flex-col gap-2.5">
                  {feature.points.map((point) => (
                    <li
                      key={point}
                      className={`flex items-start gap-2 text-xs font-light leading-[1.7] ${
                        index === 1 ? 'text-white/50' : 'text-[#8A8A8A]'
                      }`}
                    >
                      <i
                        className={`ri-check-line mt-0.5 text-sm flex-shrink-0 ${
                          index === 1 ? 'text-[#7B1113]' : 'text-[#2D6A4F]'
                        }`}
                      />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}